class StayAISubscriptions extends HTMLElement {
  // Observed attributes
  static get observedAttributes() {
    return ["data-subscription-widget", "data-subscription-style"];
  }

  constructor() {
    super();

    this.attachShadow({ mode: "open" });

    // Default data if no data is passed
    this.retextionData = {
      retextionAppId: "5859381",
      product: {},
      currentVariant: {},
      sellingPlanGroups: [],
      show_purchase_options: true,
      purchase_type_label: "Purchase Type",
      frequency_heading: "Frequency",
      one_time_purchase_label: "One Time Purchase",
      subscription_label: "Subscribe & Save",
      default_to_subscription: false,
      default_to_subscription_on_variant_change: false,
      frequencyVisible: true,
      show_subscription_details: true,
      icon_path:
        "<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' ><path fill='currentColor' d='M13.64 2.35C12.19 0.9 10.2 0 7.99 0C3.57 0 0 3.58 0 8C0 12.42 3.57 16 7.99 16C11.72 16 14.83 13.45 15.72 10H13.64C12.82 12.33 10.6 14 7.99 14C4.68 14 1.99 11.31 1.99 8C1.99 4.69 4.68 2 7.99 2C9.65 2 11.13 2.69 12.21 3.78L8.99 7H15.99V0L13.64 2.35Z'></path></svg>",
      subscription_details_box_button_text: "Subscription Details",
      subscription_details_box_title: "How subscriptions work",
      subscription_details_box_content:
        "Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.",
      widget_layout: "standard",
      requiresPlan: false,
      productFormId: "form[action='/cart/add']",
    };
    this.previousRetextionData = {};
    this.subscriptionWidget = null;
    this.purchaseTypeOneTime = null;
    this.purchaseTypeSubscription = null;
    this.radioOneTime = null;
    this.radioSubscription = null;
    this.subscriptionBox = null;
    this.sellingPlanSelector = null;

    this.shadowRoot.innerHTML = `
      <div class="stay-ai-subscriptions is-visible">
        <span class="purchaseTypeLbl"></span>
        
        <div data-rtx-subscription class="rtx-subscription">
          <div class="widget">
            <label class="rtx-purchase-label is-selected" for="purchaseTypeOneTime">
              <div class="purchase-label">
                <div class="rtx-purchase-label__inner">
                  <input type="radio" id="purchaseTypeOneTime" name="purchaseType" value="purchaseTypeOneTime" checked/>
                  <span class="one-time-purchase-label"></span>
                </div>
                <span data-rtx-onetime-price></span>
              </div>
            </label>
            
            <label class="rtx-purchase-label" for="purchaseTypeSubscription">
              <div class="purchase-label">
                <div class="rtx-purchase-label__inner">
                  <input type="radio" id="purchaseTypeSubscription" name="purchaseType" value="purchaseTypeSubscription" />
                  <span class="subscription-label"></span>
                  <span class="subscription-savings"></span>
                </div>
                <span data-rtx-subscription-price></span>
              </div>
            </label>
          </div>

          <!-- Subscription frequency selector -->
          <div data-retextion-subscription-box class="rtx-subscription-box">
            <span class="frequency-heading"></span>
            <select class="rtx-subscription-dropdown" name="rtx_selling_plan">
              <option value="">Select frequency</option>
              <!-- Selling Plan Options will go here -->
            </select>
          </div>

          <!-- Subscription Detail Box -->
          <div class="rtx-subscription-details-box">
            <button type="button" class="rtx-modal-button" data-rtx-modal-open>
              <span class="icon-container"></span>
              <span class="subscription-details-button-text"></span>
            </button>
            <div class="rtx-modal" data-rtx-modal>
              <div class="rtx-modal__content">
                <span class="subscription-details-title"></span>
                <p class="subscription-details-content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>      
    `;
  }

  // Called when the data-subscription-widget attribute changes
  attributeChangedCallback(name, oldValue, newValue) {
    

    if (this.subscriptionBox == null) {
      this.subscriptionWidget = this.shadowRoot.querySelector(
        `.stay-ai-subscriptions`
      );
      this.purchaseTypeOneTime = this.shadowRoot.querySelector(
        '[for="purchaseTypeOneTime"]'
      );
      this.purchaseTypeSubscription = this.shadowRoot.querySelector(
        '[for="purchaseTypeSubscription"]'
      );
      this.radioOneTime = this.shadowRoot.querySelector(
        '[value="purchaseTypeOneTime"]'
      );
      this.radioSubscription = this.shadowRoot.querySelector(
        '[value="purchaseTypeSubscription"]'
      );
      this.subscriptionBox = this.shadowRoot.querySelector(
        "[data-retextion-subscription-box]"
      );
      this.sellingPlanSelector = this.shadowRoot.querySelector(
        ".rtx-subscription-dropdown"
      );
    }

    if (name === "data-subscription-widget" && newValue) {
      // Skip processing if value hasn't changed.
      if (
        this.previousRetextionData &&
        JSON.stringify(this.previousRetextionData) === JSON.stringify(newValue)
      )
        return;

      let newData = JSON.parse(newValue);
      this.updateWidgetIfChanged(newData);
      // Initialize event listeners
      this.setupEventListeners();
    }

    // Apply styles if the data-subscription-style attribute changes
    if (name === "data-subscription-style" && newValue) {
      let newStyle = JSON.parse(newValue);
      this.applyStyles(newStyle);
    }
  }

  updateWidgetIfChanged(newData) {
    // Only update the widget if the value has changed from the previous data


    if (JSON.stringify(this.previousRetextionData) === JSON.stringify(newData))
      return;

    this.retextionData = { ...newData };

    if (
      this.retextionData.purchase_type_label !==
      this.previousRetextionData.purchase_type_label
    ) {
      this.shadowRoot.querySelector(".purchaseTypeLbl").textContent =
        this.retextionData.purchase_type_label;
    }
    if (
      this.retextionData.one_time_purchase_label !==
      this.previousRetextionData.one_time_purchase_label
    ) {
      this.shadowRoot.querySelector(".one-time-purchase-label").textContent =
        this.retextionData.one_time_purchase_label;
    }
    if (
      this.retextionData.subscription_label !==
      this.previousRetextionData.subscription_label
    ) {
      this.shadowRoot.querySelector(".subscription-label").textContent =
        this.retextionData.subscription_label;
    }

    if (this.retextionData.icon_path !== this.previousRetextionData.icon_path) {
      const iconContainer = this.shadowRoot.querySelector(".icon-container");
      iconContainer.innerHTML = this.retextionData.icon_path;
    }

    if (
      this.retextionData.subscription_details_box_button_text !==
      this.previousRetextionData.subscription_details_box_button_text
    ) {
      this.shadowRoot.querySelector(
        ".subscription-details-button-text"
      ).textContent = this.retextionData.subscription_details_box_button_text;
    }

    if (
      this.retextionData.subscription_details_box_title !==
      this.previousRetextionData.subscription_details_box_title
    ) {
      this.shadowRoot.querySelector(".subscription-details-title").textContent =
        this.retextionData.subscription_details_box_title;
    }

    if (
      this.retextionData.subscription_details_box_content !==
      this.previousRetextionData.subscription_details_box_content
    ) {
      this.shadowRoot.querySelector(".subscription-details-content").innerHTML =
        this.retextionData.subscription_details_box_content;
    }

    if (
      this.retextionData.default_to_subscription !==
      this.previousRetextionData.default_to_subscription
    ) {
      const isDefaultToSubscription =
        this.retextionData.default_to_subscription;
      const isSubscriptionSelected = this.isSubscriptionOptionSelected();

      // If default is subscription and subscription is not selected
      if (isDefaultToSubscription && !isSubscriptionSelected) {
        this.switchClassState(this.purchaseTypeOneTime, null, "is-selected");
        this.switchClassState(
          this.purchaseTypeSubscription,
          "is-selected",
          null
        );
        this.toggleRadioButtons();
      }
      // If default is not subscription and one-time is not selected
      else if (!isDefaultToSubscription && isSubscriptionSelected) {
        this.switchClassState(this.purchaseTypeOneTime, "is-selected", null);
        this.switchClassState(
          this.purchaseTypeSubscription,
          null,
          "is-selected"
        );
        this.toggleRadioButtons();
      }
    }

    if (
      this.retextionData.frequency_heading !==
      this.previousRetextionData.frequency_heading
    ) {
      this.shadowRoot.querySelector(".frequency-heading").textContent =
        this.retextionData.frequency_heading;
    }

    // Populate the frequency selector with selling plans if available
    if (
      this.retextionData.currentVariant &&
      this.previousRetextionData.currentVariant !=
        this.retextionData.currentVariant &&
      this.retextionData.currentVariant.selling_plan_allocations.length > 0
    ) {
     

      this.switchClassState(this.subscriptionWidget, "is-visible", null);
      this.updateSellingPlans();
    } else {
      // If no plans are available, hide the subscription box
     
      this.switchClassState(this.subscriptionWidget, null, "is-visible");
      this.updateSellingPlanInput("");
    }

    //Update data
    this.previousRetextionData = { ...newData };   
  }

  // Set up event listeners for the purchase type, frequency and variant selector
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.shadowRoot.querySelectorAll(
      'input[name="purchaseType"]'
    );
    const variantSelectors = document.querySelectorAll('[name="id"]');

    // Add event listeners to the purchase type radio buttons
    purchaseTypeRadioButtons.forEach((radio) => {
      radio.addEventListener("change", () => {
        if (radio.value === "purchaseTypeSubscription") {
          this.showSubscriptionBox();
        } else {
          this.hideSubscriptionBox();
        }
        this.updateProductPrice(this.sellingPlanSelector.value);
      });
    });

    // Add event listener to the frequency selector to update the selling plan
    this.sellingPlanSelector.addEventListener("change", (e) => {
      
      this.updateSellingPlanInput(e.target.value);
      this.updateProductPrice(e.target.value);
    });

    // Add event listener to the variant selectors to update the variant
    variantSelectors.forEach((variantSelector) => {
      variantSelector.addEventListener("change", (e) => {
        const variantId = Number(e.target.value);
        if (this.previousRetextionData.currentVariant.id != variantId) {
          
          this.retextionData.currentVariant =
            this.retextionData.product.variants.find(
              (variant) => variant.id === variantId
            );
          this.updateWidgetIfChanged(this.retextionData);
        }
      });
    });
  }

  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
   
    // Get the selling plans for the current variant
    const sellingPlans = [];
    this.retextionData.currentVariant.selling_plan_allocations.forEach(
      (spa) => {
        const group = this.retextionData.sellingPlanGroups.find(
          (g) => g.id === spa.selling_plan_group_id
        );
        if (group) {
          const plan = group.selling_plans.find(
            (sp) => sp.id === spa.selling_plan_id
          );
          if (plan) {
            sellingPlans.push(plan);
          }
        }
      }
    );


    // Clear existing options
    this.sellingPlanSelector.innerHTML = "";

    // Populate the dropdown with selling plan options
    sellingPlans.forEach((plan) => {
      const option = document.createElement("option");
      option.value = plan.id;
      option.textContent = plan.options[0].value;
      this.sellingPlanSelector.appendChild(option);
    });

    // Add a "Select frequency" option
    if (!this.isSubscriptionOptionSelected()) {
      this.addSelectFrequencyOption();
      this.updateSellingPlanInput("");
      this.switchClassState(this.subscriptionBox, null, "is-visible");
    } else {
      this.updateSellingPlanInput(sellingPlans[0].id);
      this.switchClassState(this.subscriptionBox, "is-visible", null);
    }

    // Update prices
    let sellingPlanId = this.isSubscriptionOptionSelected()
      ? this.sellingPlanSelector.value
      : sellingPlans[0].id;
    this.updateProductPrice(sellingPlanId);
  }

  // Add a "Select frequency" option
  addSelectFrequencyOption() {
    if (![...this.sellingPlanSelector.options].some((o) => o.value === "")) {
      const defaultOption = document.createElement("option");
      defaultOption.value = "";
      defaultOption.textContent = "Select frequency";
      defaultOption.selected = true;
      this.sellingPlanSelector.insertBefore(
        defaultOption,
        this.sellingPlanSelector.firstChild
      );
    }
  }

  // Show the subscription frequency selector
  showSubscriptionBox() {
    this.switchClassState(this.subscriptionBox, null, "disable");
    this.switchClassState(this.subscriptionBox, "is-visible", null);
    this.switchClassState(this.purchaseTypeSubscription, "is-selected", null);
    this.switchClassState(this.purchaseTypeOneTime, null, "is-selected");

    // Remove the "Select frequency" option
    this.sellingPlanSelector.querySelector('option[value=""]')?.remove();
    this.updateSellingPlanInput(this.sellingPlanSelector.value);
  }

  // Hide the subscription frequency selector
  hideSubscriptionBox() {
    if (!this.frequencyVisible)
      this.switchClassState(this.subscriptionBox, null, "is-visible");
    // Add the "Select frequency" option
    this.addSelectFrequencyOption();
    this.switchClassState(this.subscriptionBox, "disable", null);
    this.switchClassState(this.purchaseTypeSubscription, null, "is-selected");
    this.switchClassState(this.purchaseTypeOneTime, "is-selected", null);
    this.updateSellingPlanInput("");
    //this.updateSellingPlans();
  }

  // Check if the subscription option is selected
  isSubscriptionOptionSelected() {
    return this.purchaseTypeSubscription.classList.contains("is-selected");
  }

  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    const productForm =
      this.retextionData.productFormId && this.retextionData.productFormId != ""
        ? document.querySelector(`#${this.retextionData.productFormId}`)
        : document.querySelector(
            `form[action='/cart/add'][data-type='add-to-cart-form']`
          );

    if (!productForm) return;

    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector(
      "input[name='selling_plan']"
    );
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    } else {
      sellingPlanInput.value = sellingPlanId;
    }
  }

  // Update the prices based using the selling plan ID
  updateProductPrice(sellingPlanId) {
  
    const selectedSellingPlanAllocation =
      this.retextionData.currentVariant.selling_plan_allocations.find(
        (spa) => spa.selling_plan_id == sellingPlanId
      );
    const sellingPlan = this.retextionData.sellingPlanGroups
      .find((group) => group.selling_plans.some((sp) => sp.id == sellingPlanId))
      ?.selling_plans.find((sp) => sp.id == sellingPlanId);

    const oneTimeLblPrice = this.shadowRoot.querySelector(
      "[data-rtx-onetime-price]"
    );
    const subscriptionLblPrice = this.shadowRoot.querySelector(
      "[data-rtx-subscription-price]"
    );
    const savingLbl = this.shadowRoot.querySelector(".subscription-savings");
    const onetimePrice = this.formatMoney(
      this.retextionData.currentVariant.price
    );
    var subscriptionPrice = onetimePrice;

    // Update one-time price if it differs
    if (oneTimeLblPrice && onetimePrice !== oneTimeLblPrice.textContent)
      oneTimeLblPrice.textContent = onetimePrice;

    // Update subscription price and savings if different
    if (selectedSellingPlanAllocation) {
      subscriptionPrice = this.formatMoney(selectedSellingPlanAllocation.price);

      if (
        subscriptionLblPrice &&
        subscriptionPrice !== subscriptionLblPrice.textContent
      ) {
        if (subscriptionPrice != onetimePrice)
          subscriptionLblPrice.innerHTML = `<s class="fullPrice">${onetimePrice}</s>${subscriptionPrice}`;
      }

      //Update savings label
      let discount =
        this.retextionData.currentVariant.price -
        selectedSellingPlanAllocation.price;
    
      if (discount > 0) {
        if (sellingPlan?.price_adjustments[0].value_type === "percentage") {
          discount = sellingPlan.price_adjustments[0].value;
          if (discount > 0 && savingLbl.textContent != `${discount}%`) {
            savingLbl.textContent = `${discount}%`;
          }
        } else {
          // For fixed amount discount
          discount = this.formatMoney(discount);
          if (savingLbl.textContent != discount)
            savingLbl.textContent = discount;
        }
      } else {
        savingLbl.textContent = "";
      }
    }

    //The product price label varies depending on the theme
    /****** Update to fit your theme *****/
    const priceLabel = document.querySelector(
      ".product__detail-content .product-actual-price"
    );

    // Update the product price label based on the selected purchase type
    if (priceLabel)
      if (this.isSubscriptionOptionSelected()) {
        if (priceLabel.textContent != subscriptionPrice)
          priceLabel.textContent = subscriptionPrice;
      } else {
        if (priceLabel.textContent != onetimePrice)
          priceLabel.textContent = onetimePrice;
      }
  }

  //Helper function to add or remove classes
  switchClassState(element, addClass, removeClass) {
    if (!element) return;

    // Only make changes if the class has changed
    if (addClass && !element.classList.contains(addClass)) {
      element.classList.add(addClass);
    }

    if (removeClass && element.classList.contains(removeClass)) {
      element.classList.remove(removeClass);
    }
  }

  // Toggle checked state based on the currently checked radio button
  toggleRadioButtons() {
    this.radioOneTime.checked = !this.radioOneTime.checked;
    this.radioSubscription.checked = !this.radioSubscription.checked;
  }

  // Format money based on Shopify's active currency
  formatMoney(money) {
    const currencySymbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      JPY: "¥",
      CAD: "C$",
      AUD: "A$",
      CHF: "CHF",
      CNY: "¥",
      SEK: "kr",
      NZD: "NZ$",
    };

    const activeCurrency = Shopify.currency.active;
    const currencySymbol = currencySymbols[activeCurrency] || activeCurrency;
    const formattedMoney = (money / 100).toFixed(2);
    var formatted;

    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        formatted = window.Shopify.formatMoney(money);
        if (formatted) return formatted;
      }

      if (
        window.theme &&
        window.theme.utils &&
        typeof window.theme.utils.formatMoney === "function"
      ) {
        formatted = theme.utils.formatMoney(money);
        if (formatted) return formatted;
      }
      return `${currencySymbol}${formattedMoney}`;
    } catch (error) {
      console.error("Error formatting money:", error);
      return `${currencySymbols["USD"]}${formattedMoney}`;
    }
  }

  // Apply styles to the widget
  applyStyles(settings) {
    const style = document.createElement("style");

    //Widget layout
    let layoutCSS = "";
    if (settings.widget_layout === "stacked-buttons") {
      layoutCSS = `.rtx-purchase-label input{
          display: none!important;
        }`;
    } else if (settings.widget_layout === "side-by-side-buttons") {
      layoutCSS = `.widget{
                    align-items: center;
                    flex-direction: row;
                    gap:10px;
                }
                .purchase-label{
                    flex-direction: column;
                    align-items: center;
                }
                .rtx-purchase-label input{
                  display: none!important;
                }
                .rtx-purchase-label__inner{
                margin-bottom: 10px;
                }`;
    }
    if (settings.subscription_label_first) {
      layoutCSS += `.rtx-purchase-label:last-of-type{
            order: 1;
        }
        .rtx-purchase-label:first-of-type{
            order: 2;
        }`;
    }

    style.textContent = `
      :host {
        --text-color: ${settings.textColor};
        --font-family: ${settings.fontFamily};
        --font-size: ${settings.fontSize};
        --border-radius: ${settings.borderRadius};
        --border-width: ${settings.borderWidth};
        --border-color: ${settings.borderColor};
        --selected-text-color: ${settings.selectedTextColor};
        --bg-color: ${settings.bgColor};
        --selected-bg-color: ${settings.selectedBgColor};
        --accent-color: ${settings.accentColor};
      }
        .stay-ai-subscriptions {
            display: none;
        }
        .stay-ai-subscriptions.is-visible {
            display: block;
        }
        .rtx-subscription,.rtx-subcription *, .purchaseTypeLbl {
            box-sizing: border-box;
            color: var(--text-color)!important;
            font-family: var(--font-family)!important;
            font-size: var(--font-size)!important;
        }
        .rtx-subscription {
            margin: 1rem 0;
        }

        .widget{
            display: flex;
            flex-direction: column;
        }

        /* Widget layout */
        ${layoutCSS}
        
        /* Purchase labels */
        .rtx-subscription label{
            width: 100%;
            cursor: pointer;
        }
        .purchase-label {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1rem;
            margin-bottom: 1rem;
            border-radius: var(--border-radius);
            border: var(--border-width) solid var(--border-color);
            background-color: var(--bg-color);
        }
        .rtx-purchase-label__inner {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            gap: 5px;
        }
        .rtx-purchase-label__inner > span {
            display: flex;
            gap: 5px;
            white-space: nowrap;
        }
        label.is-selected .purchase-label {
            color:  var(--selected-text-color);
            background-color:  var(--selected-bg-color);
            border-color: var(--selected-text-color);
        }     
        
        /* Purchase type input */
        .rtx-purchase-label input{
            width: 20px;
            height: 20px;
            display: block;
            margin: 0px;
            accent-color: var(--accent-color);
        }

        /* Price */
        label.is-selected [data-rtx-subscription-price=''], label.is-selected [data-rtx-onetime-price='']{
            color: var(--selected-text-color);
            font-weight: bold;
        }
        [data-rtx-subscription-price='']{
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
            justify-content: flex-end;
        }
        [data-rtx-subscription-price=''] s{
            font-size:13px;
            opacity: 0.7;
            color: var(--text-color);
        }
        .is-selected [data-rtx-subscription-price=''] s{
          color: var(--selected-text-color);
        }

        /* Display compare at price */
        ${
          settings.display_compare_at_price
            ? ""
            : "[data-rtx-subscription-price=''] s{display:none;}"
        }

        /* Display compare at price position */
        ${
          settings.compare_at_price_first
            ? ""
            : "[data-rtx-subscription-price='']{flex-direction: row-reverse;}[data-rtx-subscription-price='']{justify-content: flex-start;}"
        }

        /* Subscription box that displays the frequency selector */
        ${
          settings.frequencyVisible ? "" : ".rtx-subscription-box{display:none}"
        }
        
        .rtx-subscription-box.is-visible {
            display: flex;
            align-items: center;
        }  
        select[name='rtx_selling_plan']{
            width: fit-content;
            padding: 5px 20px;
            margin: 10px;
            appearance: auto;
            font-family: var(--font-family)!important;
            cursor: pointer;
            background: transparent;
            border-radius: var(--border-radius);
        }
        .hidden {
            display: none;
        }    

        /* Subscription Detail Box */
        .rtx-modal-button {
            padding: 0;
            font-size: 16px;
            background: none;
            border: none;
            text-transform: initial;
            height: auto;
            min-height: 0;
            margin-left: 0px;
            cursor: pointer;
            margin-top: 10px;
            color: var(--text_color);
            font-family: var(--font-family) !important;
            font-size: var(--font-size) !important;
        }

        /* Modal content */
        .rtx-modal__content {
            position: absolute;
            z-index: 5;
            background: white;
            width: auto;
            max-width: 25rem;
            overflow-x: hidden;
            padding: 1rem 2rem;
            font-size: 15px;
            transform: translateY(-1rem);
            margin-top: 5px;
            margin-left: 12px;
            display: none;
            opacity: 0;
            transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12),
                        0px 1px 2px 0px rgba(0, 0, 0, 0.24);
        }

        /* Modal container */
        .rtx-modal {
            z-index: 5;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
        }

        /* Hover effect for button and showing modal content */
        .rtx-modal-button:hover ~ .rtx-modal {
            opacity: 1;
            visibility: visible;
            transition: opacity 0.3s ease-out, visibility 0.3s ease-out;
        }

        .rtx-modal-button:hover + .rtx-modal .rtx-modal__content {
            display: block;
            opacity: 1;
            transform: translateY(0);
        }
        .disable{
          pointer-events: none;
          cursor: none;
          opacity: 0.5;
        }
        @media (max-width: 600px) {
         .widget {   
           flex-direction: column;
         }
         .rtx-modal__content {
              max-width: 90%;
              padding: 1rem;
              font-size: 16px;
          }
        }
    `;

    // Append the style element to the shadow root
    this.shadowRoot.appendChild(style);
  }
}

// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);
